import PropTypesUtils from '@utils/propTypes'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import c from 'classnames'
import styles from './Button.module.scss'
import Text from '@components/atoms/Text/Text'
import { useMemo } from 'react'

const Button = ({ bg, icon, underline, children, onClick, link, disabled }) => {
  const innerJsx = useMemo(
    () => (
      <div
        // onClick={link || disabled ? undefined : onClick}
        onClick={onClick ? onClick : undefined}
        className={c(['p-button type--primary', styles.base], {
          'theme--brand': bg !== 'white' && !underline,
          'theme--light': bg === 'white' && !underline,
          [styles.underline]: underline,
          [styles.disabled]: disabled,
        })}
      >
        <div className={styles.text}>
          <Text type="nav">{children}</Text>
        </div>
        {(icon && (
          <div className={styles.icon}>
            <i className={`icon icon-${icon}`} />
          </div>
        )) ||
          null}
      </div>
    ),
    [onClick, underline, icon, children, link, disabled]
  )

  return link && !disabled ? (
    <div className={styles.wrapper}>
      <Link to={link}>{innerJsx}</Link>
    </div>
  ) : (
    innerJsx
  )
}

Button.defaultProps = {
  bg: 'brand',
  icon: false,
  onClick: () => {},
  underline: false,
  disabled: false,
  event: false,
}
Button.propTypes = {
  bg: PropTypes.oneOf(['brand', 'dark', 'white']),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  underline: PropTypes.bool,
  children: PropTypesUtils.children.isRequired,
  onClick: PropTypes.func,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  event: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
}

export default Button
